// @flow

import React from 'react';
import { connect } from 'react-redux';

import InputPhone from 'client/components/form/inputPhone';
import Translate from 'client/components/translate';
import { sendSms } from 'client/actions/sms';
import { Tracking } from 'web-core/src/tracking';

import type { TranslateType } from 'types/translateType.flow';

const TRANSLATE_PREFIX = 'common.account.sms';

type State = {
  error: TranslateType | null,
  info: TranslateType | null,
  isSubmitting: boolean,
  phoneNumber: string,
};

type Props = {
  className: string | null,
  sendSms: Function,
  shouldFocus: boolean,
  smsKey: string,
  smsUrl: string,
  source: string | null,
};

class SmsInput extends React.Component<Props, State> {
  static defaultProps = {
    className: null,
    shouldFocus: false,
    smsKey: 'drive-app-link',
    smsUrl: 'drive/sms',
    source: null,
  };

  state = {
    error: null,
    info: null,
    isSubmitting: false,
    phoneNumber: '',
  };

  onSubmit = (e: SyntheticEvent<>) => {
    e.preventDefault();
    const { smsKey, smsUrl, source } = this.props;
    const { phoneNumber } = this.state;
    const phoneDigits = this.state.phoneNumber.replace(/[^\d]/g, '');
    this.setState({
      isSubmitting: true,
    });

    if (phoneDigits.length !== 10) {
      Tracking.track('SMS: Invalid Phone Number', { Source: source });
      return this.setState({
        error: { path: 'common.error.invalidPhone' },
        isSubmitting: false,
      });
    }

    return this.props
      .sendSms({
        key: smsKey,
        url: smsUrl,
        payload: {
          phone: phoneDigits,
          source,
        },
      })
      .then(() => {
        this.setState({
          isSubmitting: false,
          info: { path: `${TRANSLATE_PREFIX}.success`, using: { phoneNumber } },
          error: null,
        });
        Tracking.track('SMS: Sent', { Source: source });
      })
      .catch(() => {
        this.setState({
          isSubmitting: false,
          error: { path: `${TRANSLATE_PREFIX}.error` },
          info: null,
        });
        Tracking.track('SMS: Failed to send', { Source: source });
      });
  };

  onChange = (phoneNumber: string) => {
    this.setState({
      phoneNumber,
      error: null,
      info: null,
    });
  };

  render() {
    const { className, shouldFocus } = this.props;
    const { error, info, isSubmitting, phoneNumber } = this.state;

    return (
      <InputPhone
        id="phone-number"
        changeHandler={this.onChange}
        className={className}
        error={error}
        info={info}
        label={{ path: 'common.label.cellPhone' }}
        shouldFocus={shouldFocus}
        value={phoneNumber}>
        <button
          className={isSubmitting ? 'disabled' : ''}
          onClick={this.onSubmit}
          style={{ padding: '0 1rem' }}>
          <Translate path={`${TRANSLATE_PREFIX}.cta`} />
        </button>
      </InputPhone>
    );
  }
}

export default connect(
  null,
  { sendSms },
)(SmsInput);
